<router-outlet></router-outlet>
<div class="before">
    <div id="overlay"></div>
    <div class="splash">
        <div class="text-center">
            <img src="assets/img/logo_new_3.png" alt="logo" class="app-logo drop-shadow">
        </div>

        <div class="text-center">
            <div class="loader"></div>
            <h1 class="text-title-1">Setting things up</h1> 
            <p class="text-body-1">please wait a moment...</p>
        </div>
    </div>
</div>
